// src/components/coins/EducatorDailyCoins.js
//
// Teachers earn coins just for showing up: the first time each day they open
// their dashboard, the server pays DOUBLE what a student gets from that day's
// trail stop (10, 10, 20, 20, 30, 40, then a 100-coin bonus on day 7) into
// their class coin bank. functions/rewards.js → claimDailyTrail decides the
// amount and makes sure it's only once a day; this just asks. The popup comes
// from CoinCelebration, which watches the ledger — the same way it announces
// a coin pack bought for the class bank, so every arrival looks alike.

import React, { useEffect } from "react";
import { claimDailyTrail } from "../../services/rewardsService";
import CoinCelebration from "../celebrate/CoinCelebration";

const dayKey = () => new Date().toLocaleDateString("en-CA", { timeZone: "America/New_York" });

const EducatorDailyCoins = () => {
  useEffect(() => {
    const key = `sbl-edu-daily-${dayKey()}`;
    try {
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, "1");
    } catch {
      /* private mode — the server still only pays once */
    }
    const t = setTimeout(async () => {
      try {
        await claimDailyTrail();
      } catch {
        /* not signed in yet / functions not deployed — try again next visit */
        try {
          sessionStorage.removeItem(key);
        } catch {
          /* ignore */
        }
      }
    }, 1200); // let the dashboard settle first
    return () => {
      clearTimeout(t);
    };
  }, []);
  return <CoinCelebration />;
};

export default EducatorDailyCoins;
